import { useHttp } from "@/composables/useHttp"

export function useCategoriesHttp() {
  const http = useHttp()

  async function categoriesCount() {
    const response = await http.get('/categories/count')

    return response.data.data.count
  }

  async function categories() {
    return (await http.get('/categories')).data.data
  }

  async function category(slug: string) {
    return (await http.get(`/categories/${slug}`)).data.data
  }

  return {
    categoriesCount,
    categories,
    category,
  }
}
